/** When your routing table is too long, you can split it into small modules**/

import DesignHome from  '@/components/DesignHome'


/*import userManagerList from '@/views/designUnit/userManager/list'
import infoList from '@/views/designUnit/info/list'
import taskList from '@/views/designUnit/task/list'
import drawingList from '@/views/designUnit/drawing/list'
import supplement from '@/views/designUnit/drawing/supplement'
import drawTree from '@/views/designUnit/drawing/drawTree'
import reportList from '@/views/designUnit/report/list'
import opinionList from '@/views/designUnit/opinion/list'
import opinionTree from '@/views/designUnit/opinion/opinionTree'
import taskWaitReply from '@/views/designUnit/task/waitReply'
import taskReplyTree from '@/views/designUnit/task/replyTree'*/
const design = {
  path: '/designHome',
  name: '设计单位',
  redirect:{path:'/designHome/HOME/design'},
  meta: {design: true},
  component: DesignHome,
  children: [
		 {
      path: 'HOME/:type',
      component: () => import('@/views/inspectDraw/business/configuration/home'),
      name: 'designHOME',
      meta: {title : 'HOME'},
      hidden:true
    },
    {
      path: '/design/userManagerList',
      component: () => import('@/views/designUnit/userManager/list'),
      name: 'userManagerList',
      meta: {title : '员工管理'}
    },
    {
      path: '/design/infoList',
      component: () => import('@/views/designUnit/info/list'),
      name: 'infoList',
      meta: {title : '信息维护'}
    },
    {
      path: '/design/task',
      component: () => import('@/views/designUnit/task/list'),
      name: 'taskList',
      meta: {title : '任务分配'}
    },
    {
      path: '/design/drawing',
      component: () => import('@/views/designUnit/drawing/list'),
      name: 'drawingList',
      meta: {title : '图纸上传'}
    },
    {
      path: '/design/projectQuery',
      component: () => import('@/views/designUnit/drawing/query'),
      name: 'projectQueryList',
      meta: {title : '项目查询',
      keepAlive:true,
      keepCount:true
    }
    },
    {
      path: '/design/procedureA',
      component: () => import('@/views/designUnit/drawing/procedure'),
      name: 'designProcedure',
    },
    {
      path: '/design/report',
      component: () => import('@/views/designUnit/report/list'),
      name: 'reportList',
      meta: {title : '报表统计'}
    },
    {
      path: '/design/opinion',
      component: () => import('@/views/designUnit/opinion/list'),
      name: 'opinionList',
      meta: {title : '意见查看'}
    },
    {
      path: '/design/opinionTree',
      component: () => import('@/views/designUnit/opinion/opinionTree'),
      name: 'opinionTree',
      meta: {title : '意见查看'}
    },{
      path: '/design/supplement',
      component: () => import('@/views/designUnit/drawing/supplement'),
      name: 'supplement',
      meta: {title : '图纸上传'}
    },{
      path: '/design/drawTree',
      component: () => import('@/views/designUnit/drawing/drawTree'),
      name: 'drawTree',
      meta: {title : '图纸上传'}
    },
    {
      path: '/design/info',
      component: () => import('@/views/designUnit/drawing/info'),
      name: 'info',
      meta: {title : '图纸上传'}
    },{
      path: '/design/taskWaitReply',
      component: () => import('@/views/designUnit/task/waitReply'),
      name: 'taskWaitReply',
      meta: {title : '任务回复'},
    },{
      path: '/design/taskReplyTree',
      component: () => import('@/views/designUnit/task/replyTree'),
      name: 'taskReplyTree',
      meta: {title : '任务回复'}
    },{
      path: '/design/designinMessage',
      component: () => import('@/views/inspectDraw/business/task/inMessage'),
      name: 'designinMessage',
      hidden:true,
      meta: {title : '内部消息'}
    },{
      path: '/design/expertDownload',
      component: () => import('@/views/inspectDraw/business/expert/download'),
      name: 'expertDownload',
      meta: {title : '图纸下载'}
    },{
      path: '/design/expertDownloadList',
      component: () => import('@/views/inspectDraw/business/expert/download_list'),
      name: 'expertDownloadList',
      hidden:true,
      meta: {title : '图纸下载'}
    },{
      path: '/design/task/detail',
      component: () => import('@/views/designUnit/drawing/details'),
      name: 'designTaskDetail',
      mete:{title:'详情'}
    },{
      path: '/design/allocation',
      component: () => import('@/views/inspectDraw/business/taskChange/allocation'),
      name: 'Allocation',
      mete:{title:'项目分配'}
    }
  ]
};

export default design



// WEBPACK FOOTER //
// ./src/router/design/index.js